<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed inset-0 overflow-hidden z-[100]" @close="close">
      <!-- Fundo escurecido com desfoque -->
      <TransitionChild as="template"
        enter="ease-in-out duration-500"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in-out duration-100"
        leave-from="opacity-100"
        leave-to="opacity-0"
        style="backdrop-filter: blur(4px);"
      >
        <DialogOverlay class="absolute inset-0 bg-opacity-75 transition-opacity"
          style="background: rgba(50, 50, 50, 0.5);"
        />
      </TransitionChild>

      <div class="absolute inset-0 overflow-hidden">
        <DialogOverlay class="absolute inset-0" />

        <div class="fixed inset-y-0 right-0 flex" :style="computedStyle">
          <TransitionChild as="template"
            enter="transform transition ease-in-out duration-100 sm:duration-300"
            enter-from="translate-x-full"
            enter-to="translate-x-0"
            leave="transform transition ease-in-out duration-100 sm:duration-300"
            leave-from="translate-x-0"
            leave-to="translate-x-full"
          >
            <div :class="computedMaxWidth" class="w-screen">
              <div class="h-full flex flex-col bg-white">
                <!-- Cabeçalho -->
                <div class="p-2 px-4" :class="backgroundTitle || 'bg-gray-900'">
                  <div class="flex items-center justify-between">
                    <DialogTitle class="font-light text-white">
                      {{ type === 'create' ? $t('fields.new_slider') + ' ' + title :
                          type === 'update' ? $t('fields.update_slider') + ' ' + title : title }}
                    </DialogTitle>
                    <div class="ml-3 h-7 flex items-center">
                      <button type="button"
                        class="rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                        @click="close">
                        <span class="sr-only">Fechar</span>
                        <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Conteúdo -->
                <div class="h-full min-h-0 px-2">
                  <slot></slot>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { LinkIcon, QuestionMarkCircleIcon } from '@heroicons/vue/24/solid'

export default {
  name: 'Slider',

  props: {
    backgroundTitle: {
      type: String,
      default: '',
    },
    formClose: {
      type: Function,
      default: () => {},
    },
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
    },
    maxWidth: {
      type: String,
      default: 'max-w-xl',
    },
    adjustWidth: {
      type: String,
      default: '',
    },
  },

  computed: {
    computedMaxWidth() {
      return this.maxWidth;
    },
    computedStyle() {
      return this.adjustWidth
        ? `max-width: calc(${this.maxWidth} - ${this.adjustWidth});`
        : '';
    },
  },

  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    LinkIcon,
    QuestionMarkCircleIcon,
    XMarkIcon,
  },

  methods: {
    close() {
      this.formClose();
    },
  },
};
</script>

<style scoped>
/* Adicione estilos extras se necessário */
</style>
